import "./App.css";
import { Routes, Route } from "react-router-dom";
import ScrollToTop from "./page/ScrollToTop";

import Home from "./page/Home";
import Sosiété from "./page/Sosiété";
import Services from "./page/Services";
import Devis from "./page/Partenaires";
import Contact from "./page/Contact";

import PlafondsMursTendus from "./components/produits/plafond-tendu-maroc";
import SolutionAcoustique from "./components/produits/acoustique-maroc";
import SolutionLight from "./components/produits/light-maroc";
import ArchitectureTextil from "./components/produits/architecture-textile-maroc";
import ProtectionSolaire from "./components/produits/protection-solaire-maroc";
import SolutionArtDeco from "./components/produits/art-deco-maroc";

import US_STRETCH from "./components/produits/groupe_us/PlafondsMursTendus/plafond-mur-tendu-maroc";
import US_PRINT from "./components/produits/groupe_us/PlafondsMursTendus/papier-peint-maroc";
import US_TEXTILE from "./components/produits/groupe_us/PlafondsMursTendus/plafond-textile-maroc";

import US_ACOUSTIC_TOILE from "./components/produits/groupe_us/SolutionAcoustique/acoustique-toile-maroc";
import US_ACOUSTIC from "./components/produits/groupe_us/SolutionAcoustique/feutrine-acoustique-maroc";
import US_LEVEL from "./components/produits/groupe_us/SolutionAcoustique/panneau-acoustique-maroc";
import US_ACOUSTIC_CABINE from "./components/produits/groupe_us/SolutionAcoustique/cabine-acoustique-maroc";


import US_LIGHT_RETROECLAIRAGE from "./components/produits/groupe_us/SolutionLight/plafond-lumineux-led-maroc";
import US_LIGHT_ARCHITECTURALE from "./components/produits/groupe_us/SolutionLight/eclairage-architectural-maroc";
import US_LIGHT_DECORATIF from "./components/produits/groupe_us/SolutionLight/eclairage-decoratif-maroc";

import US_FILM_SOLAIRE from "./components/produits/groupe_us/ProtectionSolaire/film-solaire-maroc";
import US_FILM_DECORATIF from "./components/produits/groupe_us/ProtectionSolaire/film-decoratif-maroc";
import US_SOLAR_STORE from "./components/produits/groupe_us/ProtectionSolaire/store-interieur-maroc";
import US_STORE_BANNE from "./components/produits/groupe_us/ProtectionSolaire/store-banne-maroc";
import US_FACADE from "./components/produits/groupe_us/ProtectionSolaire/façade-bioclimatique-maroc";

import US_STRUCTURE from "./components/produits/groupe_us/ArchitectureTextil/structure-metallique-maroc";
import US_SHADE from "./components/produits/groupe_us/ArchitectureTextil/voile-dombrage-maroc";

import US_LIGHT_BOX from "./components/produits/groupe_us/SolutionLight/lightbox-maroc";

import US_ARTFLOW from "./components/produits/groupe_us/SolutionArtDeco/artflow-decoration-murale-maroc";
import US_WALLDRESS from "./components/produits/groupe_us/SolutionArtDeco/walldress-habillage-mural-maroc";

import US_PARKING from "./components/produits/groupe_us/ArchitectureTextil/parking-ombrage-abri-voiture-maroc";

import ProjectUnikSystem1 from "./components/Home/page_project/ProjectUnikSystem1";
import ProjectUnikSystem2 from "./components/Home/page_project/ProjectUnikSystem2";
import ProjectUnikSystem3 from "./components/Home/page_project/ProjectUnikSystem3";
import ProjectUnikSystem4 from "./components/Home/page_project/ProjectUnikSystem4";
import ProjectUnikSystem5 from "./components/Home/page_project/ProjectUnikSystem5";
import ProjectUnikSystem6 from "./components/Home/page_project/ProjectUnikSystem6";
import BlogPage from "./components/Blog/BlogPage";  
import BlogPost from "./components/Blog/BlogPost";
import NotFound from "./NotFound";

const App = () => {
  return (
    <>
      {/* 🔥 FORCE LE SCROLL EN HAUT À CHAQUE PAGE */}
      <ScrollToTop />

      <Routes>
        <Route index element={<Home />} />
        <Route path="/sosiété" element={<Sosiété />} />
        <Route path="/services" element={<Services />} />
        <Route path="/devis" element={<Devis />} />
        <Route path="/contact" element={<Contact />} />

        <Route path="/plafond-tendu-maroc" element={<PlafondsMursTendus />} />
        <Route path="/acoustique-maroc" element={<SolutionAcoustique />} />
        <Route path="/light-maroc" element={<SolutionLight />} />
        <Route path="/architecture-textile-maroc" element={<ArchitectureTextil />} />
        <Route path="/protection-solaire-maroc" element={<ProtectionSolaire />} />
        <Route path="/art-deco-maroc" element={<SolutionArtDeco />} />

        <Route path="/plafond-mur-tendu-maroc" element={<US_STRETCH />} />
        <Route path="/papier-peint-maroc" element={<US_PRINT />} />
        <Route path="/plafond-textile-maroc" element={<US_TEXTILE />} />

        <Route path="/acoustique-toile-maroc" element={<US_ACOUSTIC_TOILE />} />
        <Route path="/feutrine-acoustique-maroc" element={<US_ACOUSTIC />} />
        <Route path="/panneau-acoustique-maroc" element={<US_LEVEL />} />
        <Route path="/cabine-acoustique-maroc" element={<US_ACOUSTIC_CABINE />} />

        <Route path="/plafond-lumineux-led-maroc" element={<US_LIGHT_RETROECLAIRAGE />} />
        <Route path="/eclairage-architectural-maroc" element={<US_LIGHT_ARCHITECTURALE />} />
        <Route path="/eclairage-decoratif-maroc" element={<US_LIGHT_DECORATIF />} />
        <Route path="/lightbox-maroc" element={<US_LIGHT_BOX />} />

        <Route path="/film-solaire-maroc" element={<US_FILM_SOLAIRE />} />
        <Route path="/film-decoratif-maroc" element={<US_FILM_DECORATIF />} />
        <Route path="/store-interieur-maroc" element={<US_SOLAR_STORE />} />
        <Route path="/store-banne-maroc" element={<US_STORE_BANNE />} />
        <Route path="/façade-bioclimatique-maroc" element={<US_FACADE />} />

        <Route path="/structure-metallique-maroc" element={<US_STRUCTURE />} />
        <Route path="/voile-dombrage-maroc" element={<US_SHADE />} />
        <Route path="/parking-ombrage-abri-voiture-maroc" element={<US_PARKING />} />

        <Route path="/artflow-decoration-murale-maroc" element={<US_ARTFLOW />} />
        <Route path="/walldress-habillage-mural-maroc" element={<US_WALLDRESS />} />

        <Route path="/ProjectUnikSystem1" element={<ProjectUnikSystem1 />} />
        <Route path="/ProjectUnikSystem2" element={<ProjectUnikSystem2 />} />
        <Route path="/ProjectUnikSystem3" element={<ProjectUnikSystem3 />} />
        <Route path="/ProjectUnikSystem4" element={<ProjectUnikSystem4 />} />
        <Route path="/ProjectUnikSystem5" element={<ProjectUnikSystem5 />} />
        <Route path="/ProjectUnikSystem6" element={<ProjectUnikSystem6 />} />
        <Route path="/blog" element={<BlogPage />} />
        <Route path="/blog/:id" element={<BlogPost />} />


        {/* Page 404 */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </>
  );
};

export default App;
